import { AfterViewInit, Component, DestroyRef, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';

import { MainMenuComponent } from '../../shared/main-menu/main-menu.component';
import { AcademicsMenuComponent } from '../../shared/academics-menu/academics-menu.component';
import { ScriptLoaderService, VENDOR_SCRIPTS } from '../../script-loader.service';
import { SubscribeComponent } from '../../shared/subscribe/subscribe.component';
import { SheetRow, SheetTableService } from '../services/sheet-table.service';

@Component({
  selector: 'app-courses-offered-and-admissions',
  standalone: true,
  imports: [CommonModule, RouterLink, MainMenuComponent, AcademicsMenuComponent, SubscribeComponent],
  templateUrl: '../templates/courses-offered-and-admissions.component.html',
  styleUrls: ['../css/sheet-table.css']
})
export class CoursesOfferedAndAdmissionsComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);
  private readonly csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQbvyUafNn521CRzteDRgEhXc-s0pZGslSDndCrnH5rr47yfFyMDPIfthD6AdIvspBz_CVlWj9k8oUM/pub?gid=0&single=true&output=csv';

  readonly rows = signal<SheetRow[]>([]);
  readonly columns = signal<string[]>([]);
  readonly isLoading = signal(true);
  readonly errorMessage = signal('');

  constructor(
    private readonly scriptLoader: ScriptLoaderService,
    private readonly sheetTableService: SheetTableService
  ) { }

  ngOnInit(): void {
    this.sheetTableService
      .loadTableFromCsvUrl(this.csvUrl)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (tableData) => {
          this.rows.set(tableData.rows);
          this.columns.set(tableData.columns);
          this.isLoading.set(false);
        },
        error: () => {
          this.errorMessage.set('Unable to load courses offered and admissions data right now.');
          this.isLoading.set(false);
        }
      });
  }

  ngAfterViewInit(): void {
    document.body.classList.add('defult-home');
    this.scriptLoader
      .loadSequential(...VENDOR_SCRIPTS)
      .then(() => {
        // If vendor scripts were injected after the native load event,
        // re-dispatch it so jQuery load handlers in main.js still run.
        if (document.readyState === 'complete') {
          window.dispatchEvent(new Event('load'));
        }
      })
      .catch((error) => {
        console.error('Failed to load third-party scripts', error);
      });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('defult-home');
  }
}


